import { cx } from '@/lib/cx';

export type Variant = 'primary' | 'accent' | 'secondary' | 'ghost' | 'danger';
export type Size = 'sm' | 'md' | 'lg';

const variants: Record<Variant, string> = {
  // Ink on light; yellow on dark (BRAND.md: "primary button on dark").
  primary: 'bg-ink text-paper hover:bg-ink/90 dark:bg-yellow dark:text-yellow-ink dark:hover:bg-yellow/90',
  accent: 'bg-yellow text-yellow-ink hover:bg-yellow/90',
  secondary: 'bg-card text-ink border border-border hover:bg-muted',
  ghost: 'text-ink hover:bg-muted',
  danger: 'bg-down text-white hover:bg-down/90 dark:text-[#1C1B17]',
};
const sizes: Record<Size, string> = {
  sm: 'h-8 px-3 text-sm gap-1.5',
  md: 'h-10 px-4 text-sm gap-2',
  lg: 'h-12 px-5 text-base gap-2',
};

export function buttonClass(variant: Variant = 'secondary', size: Size = 'md', extra?: string) {
  return cx(
    'inline-flex shrink-0 items-center justify-center rounded-control font-medium whitespace-nowrap transition-colors select-none',
    'disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50',
    variants[variant],
    sizes[size],
    extra,
  );
}

export const inputClass = cx(
  'h-10 w-full min-w-0 rounded-control border border-border bg-card px-3 text-sm text-ink placeholder:text-muted-ink',
  'aria-invalid:border-down disabled:opacity-60',
);
